
import { useEffect, useState, } from "react";

export default function GoogleMapMarker({onDragEnd, ...rest}) {
    const [marker, setMarker] = useState(); // google.maps.Marker

    useEffect(() => {
        if (!marker) {
            setMarker(new window.google.maps.Marker());
        }

        // remove marker from map on unmount
        return () => {
            if (marker) {
                marker.setMap(null);
            }
        };
    }, [marker]);

    useEffect(() => {
        if (marker) {
            marker.setOptions(rest); // e.g. key, draggable, position
            marker.addListener('dragend', () => {
                // console.log('Marker dragend')
                onDragEnd(marker.getPosition()) // google.maps.LatLng
            });
        }

        return () => {
            if (marker) {
                window.google.maps.event.clearListeners(marker, 'dragend');
            }
        }
    }, [marker, rest, onDragEnd]);

    return null;
};
